export default __webpack_public_path__ + "static/media/tamdai1.e33d943f.png";